import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import ReactPaginate from 'react-paginate'
import PulseLoader from 'react-spinners/PulseLoader'

export default function Products() {
  const dispatch = useDispatch()
  const productsAll = useSelector((state) => state.products.produtos)
  const fetchProducts = useSelector((state) => state.products.loading)

  const [products, setProducts] = useState(productsAll)
  const [offset, setOffset] = useState(1)
  const [perPage] = useState(50)
  const pageCount = Math.ceil(productsAll.length / perPage)

  const [search, setSearch] = useState('')

  const stylePhoto = {
    width: '150px',
    marginTop: '25px',
    maxHeight: '150px',
  }

  const getData = async () => {
    setProducts(
      productsAll.slice(
        (offset - 1) * perPage,
        (offset - 1) * perPage + perPage
      )
    )

    if (productsAll.length < (offset - 1) * perPage) {
      setOffset(1)
    }
  }

  const handlePageClick = (e) => {
    const selectedPage = e.selected
    setOffset(selectedPage + 1)
  }

  useEffect(() => {
    getData()
  }, [offset, productsAll])

  const addDefaultSrc = (ev) => {
    ev.target.src = '/images/LOGO.png'
  }

  return (
    <div>
      <h2 className='title text-center'>Produtos</h2>

      <div>
        <div className='row'>
          <div className='col-md-3'></div>
          <div className='col-md-6'>
            <input
              type='text'
              value={search}
              onChange={(e) => {
                setSearch(e.target.value)
                if (e.target.value.trim() == '') {
                  dispatch({ type: 'FILTER_CATEGORY' })
                }
              }}
              onKeyPress={(e) => {
                if (e.code === 'Enter') {
                  dispatch({ type: 'SEARCH_PRODUCT', alvo: search })
                }
              }}
              className='form-control text-center input-text'
              placeholder='Pesquise um produto por código ou descrição'
            />
          </div>
          <div className='col-md-3' style={{ display: 'flex' }}>
            <button
              onClick={(e) =>
                dispatch({ type: 'SEARCH_PRODUCT', alvo: search })
              }
              className='btn btn-outline-success'
            >
              Pesquisar
            </button>
            {search.trim() != '' && (
              <button
                onClick={() => {
                  setSearch('')
                  dispatch({ type: 'FILTER_CATEGORY' })
                }}
                className='btn btn-link'
              >
                Limpar
              </button>
            )}
          </div>
        </div>
      </div>

      <div>
        <ReactPaginate
          previousLabel={'anterior'}
          nextLabel={'próximo'}
          breakLabel={'...'}
          breakClassName={'break-me'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={offset - 1}
        />
      </div>
      <div>
        {fetchProducts && (
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <PulseLoader
              color={'black'}
              loading={fetchProducts}
              margin={2}
              size={'12px'}
            />
            <span>Carregando lista de produtos. Aguarde um instante...</span>
          </div>
        )}
        {!fetchProducts &&
          products.map((item) => (
            <div key={item.codipro + item.foto} className='col-sm-3'>
              <div className='product-image-wrapper'>
                <div className='single-products'>
                  <div className='productinfo text-center'>
                    <img
                      src={`/images/${item.codipro}.jpg`}
                      onError={addDefaultSrc}
                      alt={item.codipro}
                      style={stylePhoto}
                    ></img>
                    <p className='small text-muted'>
                      {'Código: ' + item.codipro}
                    </p>
                    <p className='small font-weight-bold'>{item.descricao}</p>
                    <span
                      className='badge badge-pill'
                      style={{
                        cursor: 'pointer',
                        marginBottom: '10px',
                        backgroundColor: '#c9302c',
                      }}
                      onClick={() =>
                        dispatch({
                          type: 'ADD_TO_CART',
                          item: { ...item, qtd: 1 },
                        })
                      }
                    >
                      <span className='fa fa-shopping-cart' /> Adicionar no
                      carrinho
                    </span>
                    <div style={{ cursor: 'pointer', marginBottom: '15px' }}>
                      <span
                        className='badge badge-pill'
                        onClick={() =>
                          dispatch({
                            type: 'ADD_TO_CART',
                            item: { ...item, qtd: 1 },
                          })
                        }
                      >
                        +01
                      </span>
                      <span
                        className='badge badge-pill'
                        onClick={() =>
                          dispatch({
                            type: 'ADD_TO_CART',
                            item: { ...item, qtd: 10 },
                          })
                        }
                      >
                        +10
                      </span>
                      <span
                        className='badge badge-pill'
                        onClick={() =>
                          dispatch({
                            type: 'ADD_TO_CART',
                            item: { ...item, qtd: 50 },
                          })
                        }
                      >
                        +50
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}
